// extracted by mini-css-extract-plugin
export default {"headerRow":"OrganizerPlacement_headerRow__z43NU"};